import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DspEventMgmt from './components/DspEventMgmt';

export default function DspEventPage() {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Amazon DSP Events</h3>
        </Col>
      </Row>
      <Row>
        <DspEventMgmt />
      </Row>
    </Container>
  );
}
